import {DrawerConfigTitle} from '@/components/Drawer/DrawerConfigTitle'
import {useEntryConditionsData} from '@/components/Drawer/hooks/useEntryConditionsData'
import {ParamsFilterCard} from '@/components/ParamsFilterCard/ParamsFilterCard'
import {ReentryDaysInput} from '@/components/ParamsFilterCard/ReentryDaysInput'
import {useTraitCategories} from '@/hooks/useTraitCategories'
import {SecondaryButton} from '@/shared-components/Button'
import {Spinner} from '@/shared-components/Spinner'
import {Icon} from 'pepsico-ds'
import {useIntl} from 'react-intl'

export const FilterParams = () => {
  const {formatMessage} = useIntl()
  const {
    data: traitCategories,
    isPending: isTraitCategoriesPending,
    isError: isTraitCategoriesError,
    refetch: refetchTraitCategories,
  } = useTraitCategories(false)

  const {
    paramsSelectors: tempParamsSelectors,
    reentryDays: tempReentryDays,
    setParamsSelectors: setTempParamsSelectors,
    setReentryDays: setTempReentryDays,
  } = useEntryConditionsData()
  return (
    <>
      <DrawerConfigTitle subtitle={formatMessage({id: 'ENTRY_CONDITION_CONTENT.CONFIG_SUBTITLE'})} />

      <div className="flex flex-col gap-4" data-testid="entry-conditions-content">
        <ReentryDaysInput setReentryDays={setTempReentryDays} reentryDays={tempReentryDays} />
        {isTraitCategoriesPending && (
          <div className="flex justify-center py-8" data-testid="trait-categories-loading">
            <Spinner size="medium" />
          </div>
        )}
        {(isTraitCategoriesError || !traitCategories) && !isTraitCategoriesPending && (
          <div className="mt-2 flex flex-col items-start gap-2" data-testid="trait-categories-error">
            <div className="flex items-center gap-2">
              <Icon icon="error_outline" size="small" className="text-support-error-primary" />
              <p className="text-sm font-medium text-red-400">{formatMessage({id: 'GENERAL.ERROR'})}</p>
            </div>
            <SecondaryButton
              size="small"
              onClick={() => refetchTraitCategories()}
              data-testid="trait-categories-try-again-button"
            >
              {formatMessage({id: 'GENERAL.TRY_AGAIN_BUTTON'})}
            </SecondaryButton>
          </div>
        )}
        {!isTraitCategoriesPending && !isTraitCategoriesError && traitCategories && (
          <ParamsFilterCard
            paramsSelectors={tempParamsSelectors}
            setParamsSelectors={setTempParamsSelectors}
            traitCategories={traitCategories}
          />
        )}
      </div>
    </>
  )
}
